import { IFilter,IPagination, IUserInformation } from "../schemas/Exicution/exicution.schema";

export class ExecutionLoads implements IUserInformation {
  driverId?: string;
  filter?: IFilter;
  pagination?: IPagination;
  args = () => {
    if (this.driverId) {
      return {
        driverId: this.driverId,
        filter: this.filter,
        pagination: this.pagination
      };
    } else {
      return {
        filter: this.filter,
        pagination: this.pagination
      };
    }
  };
  shipmentAndFilterCount = {
    carrierTenderedFilterCount: true,
    carrierAssignedFilterCount: true,
    driverAssignedFilterCount: true,
    inTransitFilterCount: true,
    deliveredNeedsPaperWorkFilterCount: true,
    deliveredWithPaperWorkFilterCount: true,
    inTransitCount: true,
    carrierTenderedCount: true,
    driverAssignedCount: true,
    carrierAssignedCount: true,
    deliveredNeedsPaperWorkCount: true,
    deliveredWithPaperWorkCount: true,
  }
  loadDetails = {
    shipmentId: true,
    documentStatus:true,
    invoiceCreatedDateTime:true,
    transportMode: true,
    totalWeight: true,
    weightUOM: true,
    totalDistance: true,
    distanceUOM: true,
    numberOfStops: true,
    sourceTMS: true,
    shipmentTenderedCarriers : {
      recordId : true,
      shipmentId : true,
      carrierId : true,
      offeredRate : true
    },
    division: true,
    capacityType:true,
    driverAssignmentStatus: true,
    assignedCarrierId: true,
    assignedTMSCarrierId: true,
    isHazardous: true,
    isHighValue: true,
    isTemperatureControlled: true,
    equipmentType: true,
    executionStatus: true,
    startState: true,
    startCity: true,
    startDateTime: true,
    shipmentServices: {
      serviceDescription: true,
    },
    loadStop: {
      stopType: true,
      sequenceNo: true,
      locationName: true,
      addressLine1: true,
      addressLine2: true,
      city: true,
      state: true,
      country: true,
      postalCode: true,
      estimatedArrivalDateTime: true,
      plannedArrivalDateTime: true,
      actualArrivalDateTime: true,
      estimatedStopDuration: true,
      plannedDepartureDateTime: true,
      actualDepartureDateTime: true,
      appointmentEarlyDateTime: true,
      appointmentLateDateTime: true,
      actualETADateTime: true,
      plannedEtaDateTime: true,
      timeZone : true,
      appointmentState: true
    },
    shipmentInvolvedParties: {
      id: true,
      partyId: true,
      partyType: true,
      partyName: true,
      partyEmail: true,
      partyPhone: true,
    },
    assignmentTransaction: {
      transactionId: true,
      shipmentId: true,
      transactionType: true,
      driverId: true,
      driverPhone: true,
      driverEmail: true,
      status: true,
      driverName: true,
    },
    managedEquipment: true,
    totalCostAmount: true,
    costCurrency: true,
    shipmentCostItems: {
      costBreakdownDescription: true,
      costBreakdownRate: true,
      costBreakdownRateQlfr: true,
      costBreakdownQty: true,
      costBreakdownTotalAmount: true
    },
    geoTrackingStatus: true,
    carrierPro:true,
    shipmentState:true,
    assignmentStatus: true,
  };
  getRequestPayload() {
    return {
      query: {
        getShipmentsWithStopsByState: {
          __args: this.args(),
          ...this.shipmentAndFilterCount,
          inTransitShipments: this.loadDetails,
          driverAssignedShipments: this.loadDetails,
          carrierAssginedShipments: this.loadDetails,
          deliveredNeedsPaperWorkShipments: this.loadDetails,
          deliveredWithPaperWorkShipments: this.loadDetails,
          carrierTenderedShipments: this.loadDetails,
        },
      },
    };
  }
}
